module.exports = __webpack_public_path__ + "TB_Powerdown_SFX_B.wav.748d1d4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_SFX_B.wav.mp3
// module id = 501
// module chunks = 0